import React from "react";
import ReactDOM from "react-dom";
import {Link} from "react-router";
import BaseComponent from "../baseComponent.js";
import DashboardService from "../../core/services/dashboardService.js";
import InternalEvent from "../../core/constants/internalEvent.js";
import styles from "./styles.scss";
import WidgetService from "../../core/services/widgetService.js";
import WrapperWidget from "./widgets/wrapperWidget.jsx";

export default class DashboardBodyMobile extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      dashboard: props.dashboard
    };
    this.updateWidget(0);
  }

  componentDidMount() {
    let containerHeight = $(this.refs.container).height();
    $(this.refs.widgetContainer).height(containerHeight);
    this.renderWidget(0);

    window.addEventListener("resize", this.handleWindowResize, false);
    this.subscribe(InternalEvent.Dashboard.WIDGET_CHANGED, this.navigateWidget);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.unsubscribeAll();
  }

  updateWidget(widgetIndex) {
    var widgetModel = this.state.dashboard.state.dashboardState[widgetIndex].widgetModel;
    if(!widgetModel) return;
    var payload = {
      mode: "ADD",
      title: widgetModel.title,
      type: widgetModel.type,
      legends: widgetModel.legends,
      metaData: widgetModel.metaData
    };
    this.widget = WidgetService.createRealtimeWidget(payload);
    this.widgetType = widgetModel.type;
  }

  navigateWidget(index) {
    this.publish(InternalEvent.App.SHOW_PRELOADER);
    this.unmountWidget();
    this.updateWidget(index);
    this.renderWidget(index);
  }

  handleWindowResize() {
    var widgetContainer = $(this.refs.widgetContainer);
    var windowHeight = $(window).height(),
      windowWidth = $(window).width();
    $(this.refs.container).height(windowHeight - 53);
    $("#" + this.widget.id).height(windowHeight - 53);
    if(this.widgetType === "VERTICAL_AREA_BAR") widgetContainer = widgetContainer.parent();
    if(this.widgetType === "TIME_SERIES") {
      ChartUtil.resizeCharts(this.widget.id, windowHeight - 53, windowWidth);
    }
    this.publish(InternalEvent.Dashboard.WIDGET_RESIZE, {widget:widgetContainer});

    setTimeout(function(){
      this.publish(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, {widget:widgetContainer});
    }, 300);

  }

  renderWidget(index) {
    var widgetContainer = $(this.refs.widgetContainer).attr("id", this.widget.id);

    ReactDOM.render(React.createElement(
      WrapperWidget,
      {
        widget: this.widget,
        model: this.widget,
        dashboardId: this.props.dashboard.persistenceId,
        onStateChange: function() {},
        onWidgetEdit: function() {},
        onWidgetRemove: function() {},
        components: this.state.dashboard.state.dashboardState[index].widgetModel.components,
        isMobile: true
      }
    ), document.getElementById(this.widget.id));


    setTimeout(() => {
      this.publish(InternalEvent.App.HIDE_PRELOADER);
    }, 500);

  }

  unmountWidget() {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.widget.id));
    WidgetService.removeWidget(this.widget.id);
  }

  handleDashboardVariable(value) {
    const copy = JSON.parse(JSON.stringify(this.state.dashboard.variables));
    copy[dashboardId].value = value;
    return this.updateActiveDashboard(copy);
  }

  render()
  {
    return(
      <div className={["dashboard-body-mobile", styles.dashboardBodyMobileContainer].join(" ")} ref="container">
        <div ref="widgetContainer"></div>
        <div id="tooltips-container">
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardBodyMobile.jsx